var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "px-4 py-2 mt-4 rounded-lg" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { md: "6" } },
                [
                  _c("v-label", { staticClass: "label" }, [
                    _vm._v(" " + _vm._s(_vm.$t("Vision Enable")))
                  ]),
                  _c("v-switch", {
                    staticClass: "form-switch",
                    attrs: { inset: "", "hide-details": "" },
                    on: {
                      change: function($event) {
                        return _vm.onChange(
                          "visionEnabled",
                          _vm.localForm.visionEnabled
                        )
                      }
                    },
                    model: {
                      value: _vm.localForm.visionEnabled,
                      callback: function($$v) {
                        _vm.$set(_vm.localForm, "visionEnabled", $$v)
                      },
                      expression: "localForm.visionEnabled"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "6" } },
                [
                  _c("v-select", {
                    staticClass: "form-select",
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      items: _vm.generationItems,
                      label: _vm.$t("Generation *"),
                      placeholder: _vm.$t("Select Generation"),
                      attach: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.onChange("gen", _vm.localForm.generation)
                      }
                    },
                    model: {
                      value: _vm.localForm.generation,
                      callback: function($$v) {
                        _vm.$set(_vm.localForm, "generation", $$v)
                      },
                      expression: "localForm.generation"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "6" } },
                [
                  _c("v-select", {
                    staticClass: "form-select",
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      items: _vm.cameraTypes,
                      label: _vm.$t("Camera Type *"),
                      placeholder: _vm.$t("Select Generation"),
                      attach: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.onChange(
                          "cameraType",
                          _vm.localForm.cameraType
                        )
                      }
                    },
                    model: {
                      value: _vm.localForm.cameraType,
                      callback: function($$v) {
                        _vm.$set(_vm.localForm, "cameraType", $$v)
                      },
                      expression: "localForm.cameraType"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "6" } },
                [
                  _c("v-label", { staticClass: "label" }, [
                    _vm._v(" " + _vm._s(_vm.$t("Vision Status")))
                  ]),
                  _c("v-switch", {
                    staticClass: "form-switch",
                    attrs: {
                      label: _vm.$t("Active"),
                      inset: "",
                      "hide-details": ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.onChange(
                          "visionStatus",
                          _vm.localForm.visionStatus
                        )
                      }
                    },
                    model: {
                      value: _vm.localForm.visionStatus,
                      callback: function($$v) {
                        _vm.$set(_vm.localForm, "visionStatus", $$v)
                      },
                      expression: "localForm.visionStatus"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "px-4 py-2 mt-4 rounded-lg", attrs: { elevation: "2" } },
        [
          _c("v-card-title", { staticClass: "pa-0" }, [
            _c("div", { staticClass: "section-heading" }, [
              _vm._v(_vm._s(_vm.$t("DETECTION")))
            ])
          ]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { md: "5" } },
                [
                  _c("v-select", {
                    staticClass: "form-select",
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      items: _vm.oosPageItems,
                      "item-text": "name",
                      "item-value": "value",
                      label: _vm.$t("OOS Page *"),
                      placeholder: _vm.$t("Select Generation"),
                      attach: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.onChange(
                          "oosPageChange",
                          _vm.localForm.oosPageChange
                        )
                      }
                    },
                    model: {
                      value: _vm.localForm.oosPageChange,
                      callback: function($$v) {
                        _vm.$set(_vm.localForm, "oosPageChange", $$v)
                      },
                      expression: "localForm.oosPageChange"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "section-description" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("Display page when out-of-stock is detected")) +
                " "
            )
          ])
        ],
        1
      ),
      _c(
        "v-card",
        {
          staticClass: "px-4 py-2 mt-4 mb-4 rounded-lg",
          attrs: { elevation: "2" }
        },
        [
          _c("v-card-title", { staticClass: "pa-0" }, [
            _c("div", { staticClass: "section-heading" }, [
              _vm._v(_vm._s(_vm.$t("NOTIFICATIONS & ALERTS")))
            ])
          ]),
          _c("v-card-text", { staticClass: "mt-4 pa-0" }, [
            _c(
              "div",
              { staticClass: "d-flex justify-space-between mt-4" },
              [
                _c("div", [
                  _c("div", { staticClass: "alert-title" }, [
                    _vm._v(_vm._s(_vm.$t("OOS Alert")))
                  ]),
                  _c("div", { staticClass: "section-description" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("Out-of-stock notification")) + " "
                    )
                  ])
                ]),
                _c("v-switch", {
                  staticClass: "form-switch",
                  attrs: { inset: "", "hide-details": "" },
                  on: {
                    change: function($event) {
                      return _vm.onChange("oosAlert", _vm.localForm.oosAlert)
                    }
                  },
                  model: {
                    value: _vm.localForm.oosAlert,
                    callback: function($$v) {
                      _vm.$set(_vm.localForm, "oosAlert", $$v)
                    },
                    expression: "localForm.oosAlert"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex justify-space-between mt-4" },
              [
                _c("div", [
                  _c("div", { staticClass: "alert-title" }, [
                    _vm._v(_vm._s(_vm.$t("MIS Alert")))
                  ]),
                  _c("div", { staticClass: "section-description" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("Misplacement notification")) + " "
                    )
                  ])
                ]),
                _c("v-switch", {
                  staticClass: "form-switch",
                  attrs: { inset: "", "hide-details": "" },
                  on: {
                    change: function($event) {
                      return _vm.onChange("misAlert", _vm.localForm.misAlert)
                    }
                  },
                  model: {
                    value: _vm.localForm.misAlert,
                    callback: function($$v) {
                      _vm.$set(_vm.localForm, "misAlert", $$v)
                    },
                    expression: "localForm.misAlert"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex justify-space-between mt-4" },
              [
                _c("div", [
                  _c("div", { staticClass: "alert-title" }, [
                    _vm._v(_vm._s(_vm.$t("LOW Alert")))
                  ]),
                  _c("div", { staticClass: "section-description" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("Low stock level notification")) + " "
                    )
                  ])
                ]),
                _c("v-switch", {
                  staticClass: "form-switch",
                  attrs: { inset: "", "hide-details": "" },
                  on: {
                    change: function($event) {
                      return _vm.onChange("lowAlert", _vm.localForm.lowAlert)
                    }
                  },
                  model: {
                    value: _vm.localForm.lowAlert,
                    callback: function($$v) {
                      _vm.$set(_vm.localForm, "lowAlert", $$v)
                    },
                    expression: "localForm.lowAlert"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "v-expansion-panels",
        {
          staticClass: "advancedSetting",
          attrs: { flat: "", accordion: "" },
          model: {
            value: _vm.showShelfConfig,
            callback: function($$v) {
              _vm.showShelfConfig = $$v
            },
            expression: "showShelfConfig"
          }
        },
        [
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", { staticClass: "pl-0 pr-0" }, [
                _c("i", { staticClass: "throwline" }),
                _vm._v(_vm._s(_vm.$t("Shelf Config")))
              ]),
              _c("v-expansion-panel-content", [
                _c(
                  "div",
                  [
                    _c("h3", { staticClass: "section-subheading" }, [
                      _vm._v(_vm._s(_vm.$t("ESL")))
                    ]),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("v-text-field", {
                              staticClass: "form-input",
                              attrs: {
                                label: _vm.$t(
                                  "Detect Confidence: Locate ESL Threshold *"
                                ),
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                type: "number"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onChange(
                                    "esl1",
                                    _vm.localForm.esl1
                                  )
                                }
                              },
                              model: {
                                value: _vm.localForm.esl1,
                                callback: function($$v) {
                                  _vm.$set(_vm.localForm, "esl1", $$v)
                                },
                                expression: "localForm.esl1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("v-text-field", {
                              staticClass: "form-input",
                              attrs: {
                                label: _vm.$t("Locate ESL Threshold (Upper) *"),
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                type: "number"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onChange(
                                    "esl2",
                                    _vm.localForm.esl2
                                  )
                                }
                              },
                              model: {
                                value: _vm.localForm.esl2,
                                callback: function($$v) {
                                  _vm.$set(_vm.localForm, "esl2", $$v)
                                },
                                expression: "localForm.esl2"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("h3", { staticClass: "section-subheading" }, [
                      _vm._v(_vm._s(_vm.$t("PRODUCT")))
                    ]),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("v-text-field", {
                              staticClass: "form-input",
                              attrs: {
                                label: _vm.$t(
                                  "Detect Confidence: Locate Product *"
                                ),
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                type: "number"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onChange(
                                    "product1",
                                    _vm.localForm.product1
                                  )
                                }
                              },
                              model: {
                                value: _vm.localForm.product1,
                                callback: function($$v) {
                                  _vm.$set(_vm.localForm, "product1", $$v)
                                },
                                expression: "localForm.product1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("v-text-field", {
                              staticClass: "form-input",
                              attrs: {
                                label: _vm.$t("Misplacemnet Threshold: MPI *"),
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                type: "number"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onChange(
                                    "product2",
                                    _vm.localForm.product2
                                  )
                                }
                              },
                              model: {
                                value: _vm.localForm.product2,
                                callback: function($$v) {
                                  _vm.$set(_vm.localForm, "product2", $$v)
                                },
                                expression: "localForm.product2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("v-text-field", {
                              staticClass: "form-input",
                              attrs: {
                                label: _vm.$t(
                                  "Cluster Misplacemnet Threshold: MPI *"
                                ),
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                type: "number"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onChange(
                                    "product3",
                                    _vm.localForm.product3
                                  )
                                }
                              },
                              model: {
                                value: _vm.localForm.product3,
                                callback: function($$v) {
                                  _vm.$set(_vm.localForm, "product3", $$v)
                                },
                                expression: "localForm.product3"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("h3", { staticClass: "section-subheading" }, [
                      _vm._v(_vm._s(_vm.$t("REPORTS")))
                    ]),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "pa-4 rounded-lg",
                                attrs: { elevation: "2" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex justify-space-between"
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "alert-title" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Restock Shelf"))
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "config-text" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Trigger restocking workflow"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]),
                                    _c("v-switch", {
                                      staticClass: "form-switch",
                                      attrs: { inset: "", "hide-details": "" },
                                      on: {
                                        change: function($event) {
                                          return _vm.onChange(
                                            "restockShelf",
                                            _vm.localForm.restockShelf
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.localForm.restockShelf,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.localForm,
                                            "restockShelf",
                                            $$v
                                          )
                                        },
                                        expression: "localForm.restockShelf"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "pa-4 rounded-lg",
                                attrs: { elevation: "2" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex justify-space-between"
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "alert-title" },
                                        [_vm._v(_vm._s(_vm.$t("OOS Report")))]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "config-text" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Out-of-stock report generation"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]),
                                    _c("v-switch", {
                                      staticClass: "form-switch",
                                      attrs: { inset: "", "hide-details": "" },
                                      on: {
                                        change: function($event) {
                                          return _vm.onChange(
                                            "ossReport",
                                            _vm.localForm.ossReport
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.localForm.ossReport,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.localForm,
                                            "ossReport",
                                            $$v
                                          )
                                        },
                                        expression: "localForm.ossReport"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "pa-4 rounded-lg",
                                attrs: { elevation: "2" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex justify-space-between"
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "alert-title" },
                                        [_vm._v(_vm._s(_vm.$t("MIS Report")))]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "config-text" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Misplacement report generation"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]),
                                    _c("v-switch", {
                                      staticClass: "form-switch",
                                      attrs: { inset: "", "hide-details": "" },
                                      on: {
                                        change: function($event) {
                                          return _vm.onChange(
                                            "misReport",
                                            _vm.localForm.misReport
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.localForm.misReport,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.localForm,
                                            "misReport",
                                            $$v
                                          )
                                        },
                                        expression: "localForm.misReport"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "pa-4 rounded-lg",
                                attrs: { elevation: "2" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex justify-space-between"
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "alert-title" },
                                        [_vm._v(_vm._s(_vm.$t("LS Report")))]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "config-text" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Low stock report generation"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]),
                                    _c("v-switch", {
                                      staticClass: "form-switch",
                                      attrs: { inset: "", "hide-details": "" },
                                      on: {
                                        change: function($event) {
                                          return _vm.onChange(
                                            "reportLS",
                                            _vm.localForm.reportLS
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.localForm.reportLS,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.localForm,
                                            "reportLS",
                                            $$v
                                          )
                                        },
                                        expression: "localForm.reportLS"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }